import { LogoMark } from '@/components/LogoMark';
import { HOME } from '@/constants/testIds';
import { scrollToId } from '@/lib/scrollTo';

const LINKS = [
    ['Features', 'features', HOME.navFeaturesLink],
    ['How it works', 'how-it-works', HOME.navHowLink],
    ['Voice test', 'voice-test', 'footer-voice-test-link'],
    ['FAQ', 'faq', 'footer-faq-link'],
];

export const Footer = () => (
    <footer data-testid={HOME.footer} className="border-t border-white/10 py-12">
        <div className="mx-auto max-w-6xl px-6">
            <div className="flex flex-col justify-between gap-8 md:flex-row md:items-start">
                <div>
                    <div className="flex items-center gap-2.5">
                        <LogoMark className="h-6 w-6" />
                        <span className="text-[15px] font-semibold tracking-[0.18em] text-white">ENGINE</span>
                    </div>
                    <p className="mt-3 text-sm text-zinc-500">Studio Copilot for FL Studio.</p>
                </div>

                <nav className="flex flex-wrap gap-x-8 gap-y-3">
                    {LINKS.map(([label, id, testId]) => (
                        <a
                            key={id}
                            href={`#${id}`}
                            data-testid={testId}
                            onClick={scrollToId(id)}
                            className="text-sm text-zinc-400 transition-colors hover:text-white"
                        >
                            {label}
                        </a>
                    ))}
                </nav>
            </div>

            <div className="mt-10 flex flex-col gap-2 border-t border-white/10 pt-6 md:flex-row md:items-center md:justify-between">
                <p className="text-xs text-zinc-600">© 2026 ENGINE. All rights reserved.</p>
                <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-600">
                    Checkout &amp; digital delivery via Shopify — placeholder integration
                </p>
            </div>
        </div>
    </footer>
);
